import { render, staticRenderFns } from "./orderFeeTemplate.vue?vue&type=template&id=4a41da30&scoped=true"
import script from "./orderFeeTemplate.vue?vue&type=script&lang=js"
export * from "./orderFeeTemplate.vue?vue&type=script&lang=js"
import style0 from "./orderFeeTemplate.vue?vue&type=style&index=0&id=4a41da30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a41da30",
  null
  
)

export default component.exports